export default {
	NOTIFICATION_PREFERENCES: 'notification_preferences',
	ACCOUNT: 'account',
	UPGRADE: 'upgrade',
	HELP: 'help',
	MANAGE: 'manage',
	SETTINGS: 'settings',
}
